module.exports = "/_next/static/images/wireless-bdb40a3970f636fdd7e6515eabcd8db5.webp";